export default class DataExchangeCompany {
  constructor() {
    this.id = '';
    this.name = '';
    this.isSender = false;
    this.isReceiver = false;
    this.statusDeliveryNote = DataExchangeCompany.STATUS.NO_STATUS.KEY;
    this.statusInvoice = DataExchangeCompany.STATUS.NO_STATUS.KEY;
    this.internalStatusDeliveryNote = DataExchangeCompany.STATUS.NO_STATUS.KEY;
    this.internalStatusInvoice = DataExchangeCompany.STATUS.NO_STATUS.KEY;
    this.comment = '';
    this.internalComment = '';
    this.knownIssues = '';
    this.furtherInformation = '';
    this.companyAccountId = '';
    this.rank = 0;
    this.blacklisted = false;
    this.currentIssues = '';
  }

  init(dataExchangeCompany, supplierAlertConfigs) {
    this.id = dataExchangeCompany?.companyId ?? '';
    this.name = dataExchangeCompany?.name;
    this.isSender = dataExchangeCompany?.isSender ?? '';
    this.isReceiver = dataExchangeCompany?.isReceiver ?? '';
    this.statusDeliveryNote = dataExchangeCompany?.statusDln ?? '';
    this.statusInvoice = dataExchangeCompany?.statusInvoice ?? '';
    this.internalStatusDeliveryNote =
      dataExchangeCompany?.internalStatusDln ?? '';
    this.internalStatusInvoice =
      dataExchangeCompany?.internalStatusInvoice ?? '';
    this.comment = dataExchangeCompany?.statusComment ?? '';
    this.internalComment = dataExchangeCompany?.internalStatusComment ?? '';
    this.knownIssues = dataExchangeCompany?.knownIssues ?? '';
    this.furtherInformation = dataExchangeCompany?.furtherInformation ?? '';
    this.companyAccountId = dataExchangeCompany?.companyAccountId ?? '';
    this.rank = dataExchangeCompany?.rank ?? 0;
    this.blacklisted = dataExchangeCompany?.blacklisted ?? false;
    this.currentIssues = dataExchangeCompany?.currentIssues ?? '';
    this.supplierAlertConfig =
      supplierAlertConfigs.find((config) => config.companyId === this.id) ??
      null;
  }

  clone(dataExchangeCompany) {
    this.id = dataExchangeCompany?.id;
    this.name = dataExchangeCompany?.name;
    this.isSender = dataExchangeCompany?.isSender;
    this.isReceiver = dataExchangeCompany?.isReceiver;
    this.statusDeliveryNote = dataExchangeCompany?.statusDeliveryNote;
    this.statusInvoice = dataExchangeCompany?.statusInvoice;
    this.internalStatusDeliveryNote =
      dataExchangeCompany?.internalStatusDeliveryNote;
    this.internalStatusInvoice = dataExchangeCompany?.internalStatusInvoice;
    this.comment = dataExchangeCompany?.comment;
    this.internalComment = dataExchangeCompany?.internalComment;
    this.knownIssues = dataExchangeCompany?.knownIssues;
    this.furtherInformation = dataExchangeCompany?.furtherInformation;
    this.companyAccountId = dataExchangeCompany?.companyAccountId;
    this.rank = dataExchangeCompany?.rank;
    this.blacklisted = dataExchangeCompany?.blacklisted;
    this.currentIssues = dataExchangeCompany?.currentIssues;
    this.supplierAlertConfig = dataExchangeCompany?.supplierAlertConfig;
  }

  static getStatusLabel(statusKey) {
    const status = Object.keys(DataExchangeCompany.STATUS).find(
      (x) => DataExchangeCompany.STATUS[x].KEY === statusKey,
    );

    if (!status) return null;

    return DataExchangeCompany.STATUS[status].LABEL;
  }

  static getStatusRank(statusKey) {
    const status = Object.keys(DataExchangeCompany.STATUS).find(
      (x) => DataExchangeCompany.STATUS[x].KEY === statusKey,
    );

    if (!status) return DataExchangeCompany.STATUS.NO_STATUS.RANK;

    return DataExchangeCompany.STATUS[status].RANK;
  }

  // get the correct CSS class for the corresponding status
  static switchClassName(statusKey) {
    const status = Object.keys(DataExchangeCompany.STATUS).find(
      (x) => DataExchangeCompany.STATUS[x].KEY === statusKey,
    );

    if (!status) return DataExchangeCompany.STATUS.NO_STATUS.CLASS;

    return DataExchangeCompany.STATUS[status].CLASS;
  }

  static STATUS = {
    CONFIRMED: {
      CLASS: 'data-exchange-status-confirmed',
      DESCRIPTION:
        'Der Lieferant will mit der Umsetzung beginnen und VESTIGAS wartet auf erste Testdatensätze',
      KEY: 'confirmed',
      LABEL: 'Zusage erteilt',
      RANK: 7,
    },
    IMPLEMENTATION_SUPPLIER: {
      CLASS: 'data-exchange-status-implementation-supplier',
      DESCRIPTION:
        'Ggf. notwendige Anpassungen an der Schnittstelle werden vom Lieferanten implementiert',
      KEY: 'implementation_supplier',
      LABEL: 'Implementierung Lieferant',
      RANK: 4,
    },
    IMPLEMENTATION_VESTIGAS: {
      CLASS: 'data-exchange-status-implementation-vestigas',
      DESCRIPTION:
        'Ein notwendiger Datenparser wird von VESTIGAS implementiert',
      KEY: 'implementation_vestigas',
      LABEL: 'Implementierung VESTIGAS',
      RANK: 5,
    },
    IN_QUALIFICATION: {
      CLASS: 'data-exchange-status-in-qualification',
      DESCRIPTION:
        'Der Lieferant hat sich zurückgemeldet und fixiert ein Gespräch mit VESTIGAS',
      KEY: 'in_qualification',
      LABEL: 'Gespräch mit Lieferant',
      RANK: 9,
    },
    INTERESTED: {
      CLASS: 'data-exchange-status-interested',
      DESCRIPTION:
        'Es wurde Interesse bekundet und der Abnehmer meldet dieses Interesse beim Lieferanten',
      KEY: 'interested',
      LABEL: 'Interesse bekundet',
      RANK: 10,
    },
    LIVE: {
      CLASS: 'data-exchange-status-live',
      DESCRIPTION: 'Produktive Anbindung',
      KEY: 'live',
      LABEL: 'Live',
      RANK: 1,
    },
    NO_STATUS: {
      CLASS: 'data-exchange-status-no-status',
      DESCRIPTION: 'Kein Status vergeben',
      KEY: 'no_status',
      LABEL: 'Kein Status',
      RANK: 11,
    },
    NOT_FEASIBLE: {
      CLASS: 'data-exchange-status-not-feasible',
      DESCRIPTION: 'Anbindung ist nicht möglich',
      KEY: 'not_feasible',
      LABEL: 'Anbindung nicht möglich',
      RANK: 12,
    },
    ON_HOLD_SUPPLIER: {
      CLASS: 'data-exchange-status-on-hold-supplier',
      DESCRIPTION:
        'Lieferant benötigt Zeit, technische Möglichkeiten intern abzuklären oder die benötigten Ressourcen bereitzustellen',
      KEY: 'on_hold_supplier',
      LABEL: 'Interne Absprachen beim Lieferant',
      RANK: 8,
    },
    QR_CODE: {
      CLASS: 'data-exchange-status-qr-code',
      DESCRIPTION: '',
      KEY: 'qr_code',
      LABEL: 'QR-Code Anbindung',
      RANK: 2,
    },
    TEST_DATA_EXCHANGED: {
      CLASS: 'data-exchange-status-test-data-exchanged',
      DESCRIPTION:
        'Erste Testdaten wurden zwischen VESTIGAS und dem Lieferanten ausgetauscht',
      KEY: 'test_data_exchanged',
      LABEL: 'Testdaten wurden ausgetauscht',
      RANK: 6,
    },
    TEST_PHASE: {
      CLASS: 'data-exchange-status-test-phase',
      DESCRIPTION:
        'Die Schnittstelle wurde hergestellt, befindet sich aber noch in einer Testphase (bevor ein Dauerbetrieb möglich ist)',
      KEY: 'test_phase',
      LABEL: 'Testphase',
      RANK: 3,
    },
  };
}
